import React from "react";

import { ImageBanner, Locations, Links } from "components";

import { withRedux, isDigit, getTextColor } from "helpers";
import { Hr } from "appStyles";

import * as styles from "./aboutUs.styles";

class AboutUs extends React.Component {
  onClick(idx) {
    let {
      actions: { updateActiveEditor },
    } = this.props;

    updateActiveEditor(idx);
  }

  render() {
    const {
      activeApp,
      business,
      activeTemplate: { backgroundColor },
      activeTemplate,
    } = this.props;
    const { links, website, mainImageLink } = activeApp;

    const textColour = getTextColor(backgroundColor);

    let locations, name;
    if (business) {
      locations = business.locations;
      name = business.name;
    }

    return (
      <div className={styles.container}>
        <div className={styles.ImageContainer}>
          {mainImageLink ? (
            <img src={mainImageLink} className={styles.image} />
          ) : null}
        </div>
        <h2
          className={styles.title}
          style={{ color: textColour, marginTop: "20px" }}
        >
          {name}
        </h2>
        {name && <Hr />}

        {locations.length > 0 ? (
          <h2 className={styles.title} style={{ color: textColour }}>
            Locations & Hours
          </h2>
        ) : null}
        <Locations
          locations={locations}
          onClick={this.onClick.bind(this)}
          color={textColour}
        />
        {!links.every((link) => link.url === "") && (
          <h2 className={styles.title} style={{ color: textColour }}>
            Follow Us!
          </h2>
        )}
        <Links links={links} />
      </div>
    );
  }
}

export default withRedux(AboutUs);
